import React from 'react';
import loadable from '@loadable/component';

const Carousel = ({ children, fields, params, lang = 'en', className = '', arrow }) => {
  const CarouselComponent = loadable(() => import('./shared/main'), { ssr: false });
  return (
    <CarouselComponent
      fields={fields}
      params={params}
      lang={lang}
      className={className}
      arrow={arrow}
    >
      {children}
    </CarouselComponent>
  );
};

export default Carousel;
